/**
 * Converts camelCase to Title Case With Spaces
 */
export function humanizeFieldName(fieldName: string): string {
    const withSpaces = fieldName.replace(/([A-Z])/g, ' $1').trim();
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

/**
 * Creates a human-readable field name from a Zod path array
 */
export function createFieldNameFromPath(path: (string | number)[]): string {
    if (path.length === 0) return 'Unknown Field';

    // Filter out UUIDs, array indices, and "set", then humanize the remaining parts
    const meaningfulParts = path.filter((part) => {
        if (typeof part === 'number') return false;
        if (typeof part === 'string') {
            // Check if it's a UUID pattern
            const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            if (uuidPattern.test(part)) return false;

            // Filter out "set" (case-insensitive)
            if (part.toLowerCase() === 'set') return false;
        }
        return true;
    });

    if (meaningfulParts.length === 0) return 'Field';

    // Humanize and join the parts
    return meaningfulParts.map((part) => humanizeFieldName(String(part))).join(' - ');
}
